import React, { useState } from 'react';
import { Search, BarChart3, Edit2, Copy, Trash2 } from 'lucide-react';
import useFeedbackManagementStore from '@/stores/AdminStore/FeedbackManagementStore';
import './FormLibrary.css';

const FormLibrary: React.FC = () => {
  const { surveys } = useFeedbackManagementStore();

  const [searchTerm, setSearchTerm] = useState('');
  const [typeFilter, setTypeFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');

  return (
    <div className="s-admin-feedback-form-library">
      <div className="s-admin-feedback-library-header">
        <h3>Survey Library</h3>
        <p>Manage all your surveys and feedback forms</p>

        <div className="s-admin-feedback-library-filters">
          <div className="s-admin-feedback-search-box">
            <Search size={18} />
            <input
              type="text"
              placeholder="Search surveys..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <select
            className="s-admin-feedback-filter-select"
            value={typeFilter}
            onChange={(e) => setTypeFilter(e.target.value)}
          >
            <option value="all">All Type</option>
            <option value="feedback">Feedback</option>
            <option value="satisfaction">Satisfaction</option>
            <option value="assessment">Assessment</option>
          </select>

          <select
            className="s-admin-feedback-filter-select"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="all">All Status</option>
            <option value="active">Active</option>
            <option value="draft">Draft</option>
          </select>
        </div>
      </div>

      <div className="s-admin-feedback-library-table-container">
        <table className="s-admin-feedback-library-table">
          <thead>
            <tr>
              <th>SURVEY</th>
              <th>TYPE</th>
              <th>STATUS</th>
              <th>RESPONSES</th>
              <th>CREATED</th>
              <th>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {surveys?.map((survey) => (
              <tr key={survey.id}>
                <td>
                  <div className="s-admin-feedback-survey-info">
                    <div className="s-admin-feedback-survey-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect x="4" y="4" width="16" height="16" rx="2" fill="#F97316" opacity="0.2"/>
                        <rect x="7" y="7" width="10" height="2" fill="#F97316"/>
                        <rect x="7" y="11" width="10" height="2" fill="#F97316"/>
                        <rect x="7" y="15" width="6" height="2" fill="#F97316"/>
                      </svg>
                    </div>
                    <div>
                      <div className="s-admin-feedback-survey-name">{survey.name}</div>
                      <div className="s-admin-feedback-survey-description">{survey.description}</div>
                    </div>
                  </div>
                </td>
                <td>
                  <span className={`s-admin-feedback-type-badge s-admin-feedback-type-badge-${survey.type.toLowerCase()}`}>
                    {survey.type}
                  </span>
                </td>
                <td>
                  <span className={`s-admin-feedback-status-badge s-admin-feedback-status-badge-${survey.status}`}>
                    {survey.status}
                  </span>
                </td>
                <td>
                  <div className="s-admin-feedback-responses-cell">
                    <BarChart3 size={16} />
                    <span>{survey.responses}</span>
                  </div>
                </td>
                <td>
                  <div className="s-admin-feedback-created-info">
                    <div className="s-admin-feedback-created-date">{survey.created}</div>
                    <div className="s-admin-feedback-created-by">by {survey.createdBy}</div>
                  </div>
                </td>
                <td>
                  <div className="s-admin-feedback-action-icons">
                    <button className="s-admin-feedback-icon-btn" title="View Analytics">
                      <BarChart3 size={16} />
                    </button>
                    <button className="s-admin-feedback-icon-btn" title="Edit">
                      <Edit2 size={16} />
                    </button>
                    <button className="s-admin-feedback-icon-btn" title="Duplicate">
                      <Copy size={16} />
                    </button>
                    <button className="s-admin-feedback-icon-btn s-admin-feedback-icon-btn-delete" title="Delete">
                      <Trash2 size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FormLibrary;
